import { dispatchError } from './utils';

export async function getManifest(
  host: string,
  name = '',
  file = '/asset-manifest.json',
): Promise<any> {
  try {
    const path = `${host}${file}`;
    const res = await fetch(path);

    if (res.status !== 200) {
      throw new Error(
        `Cannot fetch ${path}, status: ${res.status} ${res.statusText}`,
      );
    }
    /**
     * res.json() doesn't throw error if body is not JSON
     */
    return JSON.parse(await res.text());
  } catch (e) {
    dispatchError(
      name,
      `The specified host '${host}' does not exist or does not contain a manifest`,
    );
  }
}
